<template>
  
    <div>
        <div class="tw-fixed tw-bottom-0 tw-z-20 tw-right-1 tw-p-2 tw-items-end lg:tw-flex" :style="'margin-right: ' + 40  + 'px;'" >
            <div class="tw-flex tw-items-end tw-space-x-1">
                <div v-for="(chatId, index) of chatIds" :key="chatId" class="">
                    <chat :user-id="userId" :is-p-i-a="isPIA" :starting-chat-id="chatId" :start-open="false" :index="index" :ref="'chat' + chatId"></chat>
                    <!-- openedChats.includes(chatId) -->
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "MultipleChats",

    props:{
        userId: { 
        },

        isPIA: {
            default: false,
        },
        
        session: {
            type: Array,
        },
    },
 
    data() {
        return {
            chatIds: this.session ? this.session : [],
            openedChats: [],
        }
    },
    mounted(){
        EventBus.$on('add-chat', (chatId) => {
            console.log('add-chat in mounted()' + chatId);
            let presentChatId = this.chatIds.find(chat_id => chat_id == chatId);
            if(presentChatId){
                console.log('found chatId' + presentChatId);
                let chat = this.$refs['chat' + chatId];
                chat[0].toggleChat();
            }else{
                this.addChat(chatId);
            }
        });

        EventBus.$on('remove-chat', (chatId) => {
            
            this.removeChat(chatId);
        });
    },

    methods: {
        addChat(chatId){
            console.log('MultipleChats::addChat ' + chatId);
            axios.get('/api/chat/' + chatId + '/addToSession')
                    .then(response => {
                        console.log('adding chat:');
                        console.log(response.data);
                        // this.chats.push(response.data);
                        this.chatIds.push(chatId);
                        //this.openedChats.push(chatId);
                        // let childRefs = 'chat' + chatId;
                        this.$nextTick(() => {
                            console.log('toggling chat?');
                            let chat = this.$refs['chat' + chatId];
                            chat[0].toggleChat();
                        });
                    });
        },

        removeChat(removingChatId){
            axios.get('/api/chat/' + removingChatId + '/removeFromSession')
                    .then(response => {
                        console.log('chats remaining:');
                        console.log(response.data);

                        this.chatIds = response.data;  
                    });
        }
    }
}
</script>

<style>

</style>